import { MapType } from '@/types';
import * as React from 'react';

const SIZES: MapType = {
  16: 'M8.40016 8L5.3335 4.93333L6.26683 4L10.2668 8L6.26683 12L5.3335 11.0667L8.40016 8Z',
  20: 'M10 12.8122L5 7.81217L6.16667 6.64551L10 10.4788L13.8333 6.64551L15 7.81217L10 12.8122Z',
  24: 'M12.6 12 8 7.4 9.4 6l6 6-6 6L8 16.6l4.6-4.6Z',
};

const ChevronIcon = ({ className, size }: { className?: string; size?: number }) => {
  const d = SIZES[size ?? 24];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? 24}
      height={size ?? 24}
      fill="none"
      className={className}
    >
      <path fill="currentColor" d={d} />
    </svg>
  );
};
export default ChevronIcon;
